




















































































































































































































































































































































































































































































































































































































import {
	imprimirEtiquetasDePreco,
	//montarNomeEPrecoDaEtiqueta,
} from '@/shareds/etiquetas/impressao-de-etiquetas-de-preco'
import {
	EtiquetaDePreco,
	FiltrosDeEtiquetasDePreco,
	FormEtiquetaDePreco,
	Fornecedor,
	HistoricoDeEtiqueta,
	ItemDaTabelaDePreco,
} from '@/models'
import { displayNomeCompletoDoProduto } from '@/shareds/produto-shareds'
import { Component, Ref, Vue, Watch} from 'vue-property-decorator'
import SeletorDeLojas from "@/components/loja/SeletorDeLojas.vue"
import BuscaDeProdutoDropdown from './BuscaDeProdutoDropdown.vue'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TabelaDePreco } from '@/models'
import { FindLojaUseCase, type EtiquetaDePrecoServiceAdapter } from '@/usecases'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import request from '@/common/request'
import { obrigatorio } from '@/shareds/regras-de-form'
import { formatarMoeda } from '@/shareds/formatadores'
import { Inject } from 'inversify-props'
import { isVestcasa } from '@/shareds/utils'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import SeletorDeFornecedor from '../fornecedor/SeletorDeFornecedor.vue'
import DialogoDeHistoricoDeEtiquetas from './DialogoDeHistoricoDeEtiquetas.vue'
import SeletorDeTabelasDePrecoComParcelas from './SeletorDeTabelasDePrecoComParcelas.vue'

const CAMPOS_DE_ETIQUETA = 'CAMPOS_DE_ETIQUETA'
const FORM_DE_ETIQUETAS = 'FORM_DE_ETIQUETAS'
const ESTADO_DE_ETIQUETA = 'ESTADO_DE_ETIQUETA'
@Component({
	components: {
		BuscaDeProdutoDropdown,
		SeletorDeLojas,
		BuscaDeProduto,
		SeletorDeFornecedor,
		DialogoDeHistoricoDeEtiquetas,
		SeletorDeTabelasDePrecoComParcelas,
	},
})
export default class TelaDeEtiquetas extends Vue{
	@Ref() formularioDeProdutoEQuantidade!: HTMLFormElement
	@Ref() campoDeQuantidade!: HTMLInputElement
	@Ref() campoDeProduto!: HTMLInputElement
	@Ref() campoDeBuscaDoProduto!: BuscaDeProduto
	@Ref() dialogoDeHistorico!: DialogoDeHistoricoDeEtiquetas

	displayNomeCompletoDoProduto = displayNomeCompletoDoProduto
	tabelaSelecionadas: TabelaDePreco[] = []
	parcelasPorTabela: Record<string, number> = (() => {
		try { return JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}').parcelasPorTabela || {} } catch { return {} }
	})()
	etiqueta: EtiquetaDePreco | null = null
	quantidade: number | '' | null = 1
	busca: string | null = null

	//montarNomeEPrecoDaEtiqueta = montarNomeEPrecoDaEtiqueta
	formatarMoeda = formatarMoeda
	obrigatorio = obrigatorio
	precoDoProduto: boolean = (() => {
		try { return JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}').precoDoProduto ?? false } catch { return false }
	})()
	incluirNome: boolean = (() => {
		try { return JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}').incluirNome ?? true } catch { return true }
	})()
	formDeEtiquetas: FormEtiquetaDePreco[] = (() => {
		try { return JSON.parse(localStorage.getItem(FORM_DE_ETIQUETAS) || '[]') } catch { return [] }
	})()
	vestcasa = isVestcasa
	findLojaUseCase = new FindLojaUseCase()
	tamanhosDaEtiqueta: TamanhoDaEtiqueta[] = []
	tamanhoDaEtiquetaId: string | null = null
	produtosImportados: any[] = []
	carregandoProdutosImportados = false
	carregandoImpressao = false
	lojaCache: any | null = null

	tipoFiltro: 'produto' | 'nota' = (() => {
		try { return JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}').tipoFiltro || 'produto' } catch { return 'produto' }
	})()
	dialogoDeConfirmacaoDeTipoFiltro = false
	tipoFiltroParaMudar: 'produto' | 'nota' | null = null
	_inicializado = false
	carregandoProdutosNota = false
	produtosDaNota: any[] = []
	filtrosNota = (() => {
		try {
			const estado = JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}')
			return estado.filtrosNota || { numeroNota: '', serie: '' }
		} catch { return { numeroNota: '', serie: '' } }
	})()
	notasBuscadas = false
	fornecedor: Fornecedor | null = (() => {
		try {
			const estado = JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}')
			return estado.fornecedor || null
		} catch { return null }
	})()

	filtros: FiltrosDeEtiquetasDePreco = localStorage[CAMPOS_DE_ETIQUETA]
		? JSON.parse(localStorage[CAMPOS_DE_ETIQUETA])
		: {
			layout: 'Etiqueta de Gôndola',
			loja: null,
			incluirPreco: false,
			idTabelas: null,
			produto: null,
			etiqueta: null,
			tamanho: null,
		}

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter
	
	async created() {
		// Se loja foi salva como string ID (save legado), busca o objeto completo
		if (this.filtros.loja && typeof this.filtros.loja === 'string') {
			try {
				this.filtros.loja = await this.findLojaUseCase.findLojaById(this.filtros.loja as unknown as string)
			} catch { /* mantém como string, onChangeLoja tratará */ }
		}

		this.tamanhosDaEtiqueta = await this.etiquetaDePrecoService.findListaTamanhosDaEtiqueta()
		const produtosArmazenados = localStorage.getItem("PRODUTOS_IMPORTADOS")

		if(produtosArmazenados !== null){
			try {
				const dados = JSON.parse(produtosArmazenados)
				this.produtosImportados = Array.isArray(dados) ? dados : [dados]
			} catch (error) {
				AlertModule.setError(error)
				this.produtosImportados = []
			}
		}
		
		if (this.produtosImportados.length > 0) {
			this.carregarProdutosImportados()
		}

		// Restaurar tabelaSelecionadas após loja disponível
		await this.$nextTick()
		try {
			const estado = JSON.parse(localStorage.getItem(ESTADO_DE_ETIQUETA) || '{}')
			if (estado.tabelaIds && estado.tabelaIds.length > 0) {
				this.tabelaSelecionadas = this.tabelas.filter((t: TabelaDePreco) => estado.tabelaIds.includes(t.id))
			}
		} catch { /* ignore */ }

		this._inicializado = true
	}

	async carregarProdutosImportados() {
		if (!this.produtosImportados.length) return
		this.carregandoProdutosImportados = true

		const promises = this.produtosImportados.map(produto => {
			const etiquetaForm: FormEtiquetaDePreco = {
				layout: this.filtros.layout,
				idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
				parcelasPorTabela: this.montarParcelasPorTabela(),
				produtoId: produto.produtoId,
				sku: produto.sku,
				ean: produto.ean || '',
				nomeDoProduto: produto.nomeProduto,
				quantidade: produto.quantidade || 1,
				lojaId: this.filtros.loja ? this.filtros.loja.id : produto.loja.id,
				tamanho: this.filtros.tamanho,
			}

			this.formDeEtiquetas.push(etiquetaForm)
			return this.buscarEtiqueta(etiquetaForm)
		})

		try {
			await Promise.all(promises)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregandoProdutosImportados = false
		}
	}


	get tabelas() {
		const loja = this.lojaParaTabela
		if (!loja) return []
		const listas = loja.configuracaoDaLoja?.tabelasDePreco || []
		return listas.map(l => l.tabelaDePreco)
	}

	get nomeDaLoja(){
		const loja = this.lojaParaTabela
		return loja ? loja.nome : ''
	}
	
	get idDaLoja(){
		const loja = this.lojaParaTabela
		if (loja) return loja.id
		return typeof this.filtros.loja === 'string' ? this.filtros.loja : null
	}

	get buscaUnica() {
		return this.vestcasa
	}

	deleteItem(item: any) {
		const idx = this.formDeEtiquetas.indexOf(item)
		if (idx !== -1) {
			this.formDeEtiquetas.splice(idx, 1)
		}
	}

	formatarPrecoENomeDaEtiqueta(preco: ItemDaTabelaDePreco) {
		if(!preco) return ''
		return this.incluirNome
			? `${this.precoDoProduto ? this.displayNomeDaEtiqueta(preco.tabela) : ''} ${this.precoDoProduto
				? `- ${this.formatarPrecoComParcelas(preco, true)} - Limitação ${preco.qtdeLimitadaDoProduto}`
				: ''}`
			: `${this.precoDoProduto
				? `${this.formatarPrecoComParcelas(preco, true)} - Limitação ${preco.qtdeLimitadaDoProduto}`
				: ''}`
	}

	displayNomeDaEtiqueta(tabela: TabelaDePreco){
		return this.incluirNome ? tabela.nome : 'Varejo'
	}

	formatarPrecoComParcelas(preco: ItemDaTabelaDePreco, comEspaco = false): string {
		const valor = preco?.precoFinalVarejo || 0
		const parcelas = preco?.tabela?.id ? (this.parcelasPorTabela[preco.tabela.id] || 1) : 1
		const espaco = comEspaco ? ' ' : ''

		return parcelas > 1
			? `${parcelas}X R$${espaco}${formatarMoeda(valor / parcelas)}`
			: `R$${espaco}${formatarMoeda(valor)}`
	}

	async incluirProduto() {
		if (!this.filtros.produto) return
		if (!this.quantidade) return
		if(!this.filtros.loja){
			AlertModule.setError('Necessario selecionar uma loja!')
			return
		}
		
		const tamanhoAtualizado = this.filtros.tamanho 
			? await this.etiquetaDePrecoService.findTamanhoEtiquetaById(this.filtros.tamanho.id) 
			: null

		const etiquetaForm: FormEtiquetaDePreco = {
			layout: this.filtros.layout,
			idTabelas:  this.tabelaSelecionadas.map( ({ id}) => id),
			parcelasPorTabela: this.montarParcelasPorTabela(),
			produtoId: this.filtros.produto.id,
			sku: "",
			ean: this.filtros.produto.eans?.[0] || '',
			nomeDoProduto: displayNomeCompletoDoProduto(this.filtros.produto),
			quantidade: this.quantidade,
			lojaId: this.filtros.loja ? this.filtros.loja.id : this.produtosImportados[0].loja.id,
			tamanho: tamanhoAtualizado,
		}

		this.formDeEtiquetas.push(etiquetaForm)
		await this.buscarEtiqueta(etiquetaForm)
		
		this.quantidade = 1
		this.filtros.produto = null
		this.busca = null
		setTimeout(() => {
			this.campoDeBuscaDoProduto.focus()
		})
	}

	async buscarEtiqueta(etiquetaForm: FormEtiquetaDePreco) {
		try {
			if (!etiquetaForm.idTabelas) return
			this.etiqueta = await this.etiquetaDePrecoService.create(etiquetaForm)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async imprimirEtiquetas() {
		if(!this.filtros.loja) {
			AlertModule.setError('Loja não selecionada')
			return
		}
		if(!this.formDeEtiquetas) {
			AlertModule.setError('Nenhum produto selecionado')
			return
		}
		if(!this.filtros.tamanho){
			AlertModule.setError('Necessario selecionar um tamanho!')
			return
		}

		if(!this.idDaLoja){
			AlertModule.setError('Necessario selecionar uma Loja!')
			return
		}

		try {
			this.carregandoImpressao = true

			const tamanhoAtualizado = this.filtros.tamanho
				? await this.etiquetaDePrecoService.findTamanhoEtiquetaById(this.filtros.tamanho.id)
				: null

			const formsDeEtiqueta = this.formDeEtiquetas.map(etiqueta => ({
				...etiqueta,
				idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
				parcelasPorTabela: this.montarParcelasPorTabela(),
				lojaId: this.idDaLoja,
				incluirPreco: this.filtros.incluirPreco,
				tamanho: tamanhoAtualizado,
				layout: this.filtros.layout,
			}))

			const blob = new Blob([JSON.stringify(formsDeEtiqueta)], { type: 'application/json' })
			const file = new File([blob], 'etiquetas.json', { type: 'application/json' })

			const informacoesDosArquivos = await uploadFilesToS3([file], 'impressao-de-etiquetas')
			const urlDoArquivoJson = informacoesDosArquivos.map(({ config }) => config.url)[0]

			if (!urlDoArquivoJson) {
				AlertModule.setError('Ocorreu um erro interno, contate o suporte')
				return
			}

			const etiquetas = await request.post<never, EtiquetaDePreco[]>('/etiquetas', { urlDoArquivoJson })

			const conformeRegraDoCaixa = this.imprimirConformeRegraDeNegocioDoCaixa ? true : false
			await imprimirEtiquetasDePreco(etiquetas, this.precoDoProduto, this.incluirNome, conformeRegraDoCaixa, this.idDaLoja)
			this.salvarNoHistorico()

		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressao = false
		} finally {
			this.carregandoImpressao = false
			localStorage.removeItem('PRODUTOS_IMPORTADOS')
		}
	}
	
	salvarNoHistorico() {
		const lojaNome = this.filtros.loja && typeof this.filtros.loja === 'object'
			? (this.filtros.loja as any).nome || ''
			: ''

		const item: HistoricoDeEtiqueta = {
			id: Date.now().toString(),
			dataHora: new Date().toISOString(),
			lojaNome,
			layout: this.filtros.layout || '',
			lojaId: this.idDaLoja || '',
			formsDeEtiqueta: [...this.formDeEtiquetas],
			tabelaSelecionadas: [...this.tabelaSelecionadas],
			parcelasPorTabela: { ...this.parcelasPorTabela },
			precoDoProduto: this.precoDoProduto,
			incluirNome: this.incluirNome,
			filtros: {
				layout: this.filtros.layout,
				tamanho: this.filtros.tamanho,
				incluirPreco: this.filtros.incluirPreco,
			},
		}

		DialogoDeHistoricoDeEtiquetas.salvar(item)
	}

	async reimprimirDoHistorico(item: HistoricoDeEtiqueta) {
		try {
			this.dialogoDeHistorico.setCarregando(item.id)
			let etiquetas: EtiquetaDePreco[] = []
			const loteSize = 10
			const tamanhoAtualizado = item.filtros.tamanho
				? await this.etiquetaDePrecoService.findTamanhoEtiquetaById(item.filtros.tamanho.id)
				: null

			for (let i = 0; i < item.formsDeEtiqueta.length; i += loteSize) {
				const lote = item.formsDeEtiqueta.slice(i, i + loteSize).map(f => ({
					...f,
					idTabelas: item.tabelaSelecionadas.map(({ id }) => id),
					parcelasPorTabela: item.parcelasPorTabela || {},
					lojaId: item.lojaId,
					incluirPreco: item.filtros.incluirPreco,
					tamanho: tamanhoAtualizado,
					layout: item.filtros.layout,
				}))
				// eslint-disable-next-line no-await-in-loop
				const etiquetasDoLote = await request.post<never, EtiquetaDePreco[]>('/etiquetas', lote)
				etiquetas = [...etiquetas, ...etiquetasDoLote]
			}

			const conformeRegraDoCaixa = this.imprimirConformeRegraDeNegocioDoCaixa ? true : false
			await imprimirEtiquetasDePreco(etiquetas, item.precoDoProduto, item.incluirNome, conformeRegraDoCaixa, item.lojaId)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.dialogoDeHistorico.setCarregando(null)
		}
	}

	get imprimirConformeRegraDeNegocioDoCaixa() {
		return UserLoginStore.permiteRegraDeNegocio('imprimir-precos-das-etiquetas-conforme-regra-do-caixa')
	}

	salvarEstado() {
		localStorage.setItem(ESTADO_DE_ETIQUETA, JSON.stringify({
			precoDoProduto: this.precoDoProduto,
			incluirNome: this.incluirNome,
			tabelaIds: this.tabelaSelecionadas.map(t => t.id),
			parcelasPorTabela: this.parcelasPorTabela,
			tipoFiltro: this.tipoFiltro,
			filtrosNota: this.filtrosNota,
			fornecedor: this.fornecedor,
		}))
	}

	montarParcelasPorTabela(): Record<string, number> {
		return this.tabelaSelecionadas.reduce((acc, tabela) => {
			acc[tabela.id] = this.parcelasPorTabela[tabela.id] || 1
			return acc
		}, {} as Record<string, number>)
	}

	@Watch('filtros', { deep: true })
	onChangeFiltros() {
		if (!this._inicializado) return
		const toSave = { ...this.filtros, produto: null }
		localStorage.setItem(CAMPOS_DE_ETIQUETA, JSON.stringify(toSave))
	}

	@Watch('precoDoProduto')
	onChangePrecoDoProdutoFlag() {
		this.salvarEstado()
	}

	@Watch('incluirNome')
	onChangeIncluirNome() {
		this.salvarEstado()
	}

	@Watch('parcelasPorTabela', { deep: true })
	onChangeParcelasPorTabela() {
		this.salvarEstado()
	}

	@Watch('tabelaSelecionadas', { deep: true })
	onChangePrecoDoProduto() {
		if (this.tabelaSelecionadas.length != 0 && !this.imprimirConformeRegraDeNegocioDoCaixa) {
			this.precoDoProduto = false
		}

		const idsSelecionados = new Set(this.tabelaSelecionadas.map(t => t.id))
		this.tabelaSelecionadas.forEach(tabela => {
			if (this.parcelasPorTabela[tabela.id] === undefined) {
				this.$set(this.parcelasPorTabela, tabela.id, 1)
			}
		})
		Object.keys(this.parcelasPorTabela).forEach(id => {
			if (!idsSelecionados.has(id)) this.$delete(this.parcelasPorTabela, id)
		})

		this.salvarEstado()
	}

	async loja(lojaId){
		this.filtros.loja = await this.findLojaUseCase.findLojaById(lojaId)
	}

	@Watch('filtros.loja', { deep: true })
	async onChangeLoja(val: any) {
		if (!this.filtros.loja || !this.filtros.loja.grupoEconomico) return
		if(this.filtros.tamanho && this.filtros.tamanho.grupoEconomico && this.filtros.loja.grupoEconomico.id != this.filtros.tamanho.grupoEconomico.id){
			this.filtros.tamanho = null
		}
		this.tamanhosDaEtiqueta = await this.etiquetaDePrecoService.findListaTamanhosDaEtiqueta({grupoEconomicoId: this.filtros.loja.grupoEconomico.id})
		if (val && typeof val === 'object') this.lojaCache = val
	}

	@Watch('filtros.incluirPreco')
	async onIncluirPreco(val: boolean) {
		if (val && !this.lojaParaTabela && typeof this.filtros.loja === 'string') {
			this.lojaCache = await this.findLojaUseCase.findLojaById(this.filtros.loja)
		}
	}

	get lojaParaTabela() {
		const l = this.filtros.loja
		return l && typeof l === 'object' ? l : this.lojaCache
	}

	selecionarTipoFiltro(tipo: 'produto' | 'nota') {
		if (tipo === this.tipoFiltro) return

		if (this.formDeEtiquetas.length > 0) {
			this.tipoFiltroParaMudar = tipo
			this.dialogoDeConfirmacaoDeTipoFiltro = true
			return
		}

		this.aplicarMudancaDeTipoFiltro(tipo)
	}

	confirmarMudancaDeTipoFiltro() {
		if (!this.tipoFiltroParaMudar) return
		this.aplicarMudancaDeTipoFiltro(this.tipoFiltroParaMudar)
		this.tipoFiltroParaMudar = null
		this.dialogoDeConfirmacaoDeTipoFiltro = false
	}

	aplicarMudancaDeTipoFiltro(tipo: 'produto' | 'nota') {
		this.tipoFiltro = tipo
		this.limparProdutos()
		this.salvarEstado()
	}

	async buscarProdutosPorNota() {
		if (!this.filtrosNota.numeroNota || !this.filtrosNota.serie) {
			AlertModule.setError('Digite a serie da NFe e o número da nota')
			return
		}

		if(!this.filtros.loja){
			AlertModule.setError('Necessário selecionar uma Loja');
			return
		}

		if(!this.fornecedor) {
			AlertModule.setError('Necessário selecionar o emitente da nota')
			return
		}

		try {
			this.carregandoProdutosNota = true

			const params = {
				serie: this.filtrosNota.serie,
				numero: this.filtrosNota.numeroNota,
			}

			const produtosParaImpressao = await this.etiquetaDePrecoService.findProdutosNotaBySerieAndNnf(params, typeof this.filtros.loja === 'object' ? this.filtros.loja.id : this.filtros.loja, this.fornecedor?.id)			
			if(Array.isArray(produtosParaImpressao)){
				produtosParaImpressao.forEach(formProduto => {
					const etiquetaForm: FormEtiquetaDePreco = {
						layout: this.filtros.layout,
						idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
						parcelasPorTabela: this.montarParcelasPorTabela(),
						produtoId: formProduto.produtoId,
						sku: formProduto.sku,
						ean: formProduto.ean || '',
						nomeDoProduto: formProduto.nomeDoProduto,
						quantidade: formProduto.quantidade || 1,
						lojaId: this.filtros.loja ? this.filtros.loja.id : formProduto.lojaId,
						tamanho: this.filtros.tamanho,
					}

					this.formDeEtiquetas.push(etiquetaForm)
					return this.buscarEtiqueta(etiquetaForm)
				});
			}

			if(Array.isArray(produtosParaImpressao) && produtosParaImpressao.length >= 1){
				this.notasBuscadas = true
			}else{
				AlertModule.setError('Nenhuma nota encontrada para o filtro selecionado')
			}

		} catch (error: any) {
			AlertModule.setError('Erro ao buscar produtos da nota: ' + error.message)
		} finally {
			this.carregandoProdutosNota = false
		}
	}

	@Watch('formDeEtiquetas', { deep: true })
	onChangeFormDeEtiquetas() {
		localStorage.setItem(FORM_DE_ETIQUETAS, JSON.stringify(this.formDeEtiquetas))
	}

	@Watch('filtrosNota', { deep: true })
	onChangeFiltrosNota() {
		this.salvarEstado()
	}

	@Watch('fornecedor')
	onChangeFornecedor() {
		this.salvarEstado()
	}

	limparItens() {
		this.formDeEtiquetas = []
		this.etiqueta = null
		localStorage.removeItem(FORM_DE_ETIQUETAS)
	}

	limparProdutos(){
		this.limparItens()
		this.notasBuscadas = false
		this.fornecedor = null
		this.filtrosNota = {
			numeroNota: '',
			serie: '',
		}
		this.filtros.produto = null
		this.quantidade = 1
		this.busca = null
		this.produtosDaNota = []
	}

}
